export const songsArr = [
  //format

  // need to put blanks to fill in space, (needs to be changed to hashmap later for better readablility)
  //0 playlist name
  //1 link
  //2 artist
  //3 nowplaying name
  //4 svg
  //5 song number in songs map
  //6 spotify link
  //7 soundcloud link
  [
    "Sexy Black Timberlake",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Channel+Tres+%C2%B7+Channel+Tres+-+Sexy+Black+Timberlake.mp3",
    "Channel Tres",
  ], 
  [
    "MILO",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/BEAM+-+MILO+Coffee+Bean+Freestyle+Feat.+Vory.mp3",
    "BEAM ft. Vory",
    "MILO Coffee Bean Freestyle"
  ], 
  [
    "Smile",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/G-Unit+-+Smile-1.mp3",
    "G-Unit",
  ], 
  [
    "selfish",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/blindforlove+-+(free)+drake+x+partynextdoor+type+beat+2020+%E2%80%93+selfish+%7C+r%26b+dancehall+type+beat.mp3",
    "blindforlove",
  ], [
    "Pretty Brown Eyes",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Mint+Condition+-+Breakin'+My+Heart+(Pretty+Brown+Eyes).mp3",
    "Mint Condition",
    "Breakin' My Heart (Pretty Brown Eyes)"
  ], 
  [
    "Don't You",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/JOE+KAY+-+Don't+You+(Joe+Kay's+Slowed+Edit).mp3",
     "Joe Kay",
     "Don't You (Slowed)",

  ], 
  [
    "Exhale",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Dpat+-+Exhale.mp3",
    "Dpat",
  ], 
  [
    "DMW",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/sans+-+DMW.mp3",
    "sans",
  ], 
  [
    "PS​.​.​.​.​.​.​.​x",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/King+Krule+-+PS%E2%80%8B.%E2%80%8B.%E2%80%8B.%E2%80%8B.%E2%80%8B.%E2%80%8B.%E2%80%8B.%E2%80%8Bx.mp3",
    "King Krule",
    "PS​.​.​.​.​.​.​.​x (Kaytranada Remix)"
  ], 
  [
    "Crew",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/See+Dee+-+Crew.mp3",
    "See Dee",
  ], 
  [
    "nights",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/swell+-+nights.mp3",
    "Swell",
  ], 
  [
    "Both Of Us",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jayda+G+-+Both+Of+Us.mp3",
    "Jayda G",
  ], 
   [
    "Love Again",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Ta-ku+%C2%B7+JMSN+%C2%B7+Sango+-+Love+Again-2.mp3",
    "Ta-ku · JMSN · Sango",
  ], 
   [
    "Weak",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Sunday+Service+Choir+-+Weak.mp3",
    "Sunday Service Choir",
  ],  
  [
    "Say That Again",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Anzola+-+Say+That+Again.mp3",
    "Anzola",
  ],  
  [
    "Memphis",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/AG+Club+-+Memphis.mp3",
    "AG Club",
  ],  
  [
    "I No Go Give Up On You",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Mr+Eazi+%C2%B7+emPawa+Africa+-+I+No+Go+Give+Up+On+You.mp3",
    "Mr Eazi · emPawa Africa",
  ],  
  [
    "Try a Little Tenderness",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Pip+Millett+-+Try+a+Little+Tenderness-1.mp3",
    "Pip Millett",
  ],  
  [
    "Mashita",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Mansur+Brown+-+Mashita-1.mp3",
    "Mansur Brown",
  ],  
  [
    "Champagne Shots",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Sainte+-+Champagne+Shots.mp3",
    "Sainte",
  ],  
  [
    "Alpha",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Guapdad+4000+-+Alpha.mp3",
    "Guapdad 4000",
  ],  
  [
    "not enough",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/not+enough.wav",
    "blindforlove",
  ],  
  [
    "Rapid Fire",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Santi+featuring+Shane+Eagle%2C+Tomi+Agape+and+Amaarae+-+Rapid+Fire.mp3",
    "Santi",
  ],  
  [
    "Flight of the Navigator",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Childish+Gambino+-+I.+Flight+of+the+Navigator.mp3",
    "Childish Gambino",

  ],  
  [
    "JFSE",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jesse+James+(Solomon)+-+JFSE.mp3",
    "Jesse James (Solomon)",

  ],  
  [
    "Blue Notes",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Meek+Mill+-+Blue+Notes-1.mp3",
    "Meek Mill",

  ],  
  [
    "FEOTUS",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Edgar+The+Beatmaker+-+FEOTUS-1.mp3",
    "Edgar The Beatmaker",

  ],  
  [
    "SDP Interlude",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Travis+Scott+-+SDP+Interlude+Full+Mix.mp3",
    "Travis Scott",
    "SDP Interlude (Unreleased Extended Version)"
  ],

  [
    "Days in The East",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/trap+headz+-+Days+in+the+east-+(+sango+favela+version+)-1.mp3",
    "Drake",
    "Days in The East (Sango Favela Remix)",
  ],
  [
    "Got it Goin On",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Tom+MIsch+-+Got+It+Going+On+(feat.+A+Tribe+Called+Quest).mp3",
    "Tom Misch",
    "Got it Goin On (feat. A Tribe Called Quest)",
  ],
  [
    "Maggot Brain",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Funkadelic+-+Maggot+Brain-1.mp3",
    "Funkadelic",
  ],
  [
    "candy shop",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/50+cent+ft.+olivia+-+candy+shop+(jersey+flip).mp3",
    "paul mond",
    "candy shop 50 cent ft. olivia (jersey flip)"
  ],
  [
    "By Your Side",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/By+Your+Side+(Neptunes+Remix)+(Remastered).mp3",
    "Sade",
    "By Your Side (Neptunes Remix)",
  ],
  [
    "Sing About Me",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/10+-+Sing+About+Me%2C+I'm+Dying+Of+Thirst.mp3",
    "Kendrick Lamar"
  ],
  [
    "Aquarium",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Aquarium.mp3",
    "Nosaj Thing"
  ],
  [
    "100 Bags",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/100+Bags+(Dirty).mp3",
    "Stormzy"
  ],

  [
    "Drive Slow",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Drive+Slow+1.mp3",
    "Kanye West"
  ],
  [
    "Jazz (We've Got)",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jazz+(We've+Got)+2.mp3",
    "A Tribe Called Quest"
  ],
  [
    "The Worst",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jhene%CC%81+Aiko+-+The+Worst+(Static+Jersey+Remix)+DL+Link+In+Description.mp3",
    "Jhené Aiko ft. DJ Static",
    "The Worst (Jersey Club Remix)"
  ],
  [
    "Night 6",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Night+6.mp3",
    "Ta-ku"
  ],
  [
    "Needed Time",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Needed+Time.mp3",
    "Yung Bxne"
  ],
  [
    "When I See U",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/When+I+See+U+1.mp3",
    "Fantasia"
  ],
  [
    "Night 8",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Night+8.mp3",
    "Ta-ku"
  ],
  [
    "West District",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/West+District+2.mp3",
    "PartyNextDoor"
  ],
  [
    "LCP",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Lights%2C+Camera%2C+Passion+(feat.+Miraa+May).mp3",
    "WSTRN ft. Miraa May",
    "Lights, Camera, Passion",
  ],
  [
    "Wylin'",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Wylin'.mp3",
    "Always Never"
  ],
  [
    "Bad Energy",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Bad+Energy+(Dirty)+1.mp3",
    "Skepta ft. Wizkid"
  ],
  [
    "rain. rmx",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/1-800-RAZ+-+rain.+rmx+%5B1-800-RAZ%5D.mp3",
    "[1-800-RAZ]"
  ],
  [
    "Tungba",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Ajebutter22+%C2%B7+BOJ+-+Tungba.mp3",
    "Ajebutter 22 ft. BOJ"
  ],
  [
    "Humble Pie",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Frankie+Stew+and+Harvey+Gunn+-+Humble+Pie.mp3",
    "Frankie Stew and Harvey Gunn"
  ],
  [
    "Midnight Marauders",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/A+Tribe+Called+Quest+-+Midnight+Marauders+Tour+Guide.mp3",
    "A Tribe Called Quest",
    "Midnight Marauders Tour Guide",


  ],
  [
    "Gang Over Luv",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Brent+Faiyaz+-+Gang+Over+Luv.mp3",
    "Brent Faiyaz"
  ],
  [
    "Players",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Slum+Village+-+Players-1.mp3",
    "Slum Village",
    "Players (Instrumental)",

  ],
  [
    "Jungle Fever",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jungle+Fever+Ft.+Genio+%26+Odunsi.mp3",
    "Cruel Santino ft. Genio & Odunsi"
  ],
  [
    "A Little Piano",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/DJ+Mitsu+the+Beats+-+A+Little+Piano.mp3",
    "DJ Mitsu the Beats"
  ],
  [
    "Runaway",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Justice+Der+-+KANYE+WEST+(GUITAR+COVER).mp3",
    "justice der",
    "Runaway",
  ],
  [
    "Purple",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Nas+-+Purple-1.mp3",
    "Nas"
  ],
  [
    "No Love",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/GuiltyBeatz+%C2%B7+Joeboy+-+No+Love.mp3",
    "GuiltyBeatz ft. Joeboy"
  ],
  [
    "Slept On You",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/brysontiller+-+Slept+On+You+(Prod+by+NES).mp3",
    "Bryson Tiller",
    "Slept On You (Prod by NES)",

  ],
  [
    "Finesse",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Bryson+Tiller+-+Finesse+(Drake+Cover).mp3",
    "Bryson Tiller"
  ],
  [
    "Shannon",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/MoStack+-+Shannon.mp3",
    "MoStack"
  ],
  [
    "Reverse",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/K.+Forest+-+Reverse.mp3",
    "K. Forest"
  ],
  [
    "QueensBridge Politics",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Nas+-+QueensBridge+Politics.mp3",
    "Nas"
  ],
  [    
    "18HUNNA",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Headie+One+%C2%B7+Dave+-+18HUNNA+(Four+Tet+Remix).mp3",
    "Headie One · Dave",
    "18HUNNA (Four Tet Remix)",

  ],
  [
    "QUARANTINE CLEAN",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Turbo%2C+Gunna+%26+Young+Thug+-+QUARANTINE+CLEAN+(Dirty).mp3",
    "Turbo, Gunna & Young Thug"
  ],
  [
    "Famous",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Octavian+%C2%B7+Gunna+%C2%B7+SAINt+JHN+-+Famous.mp3",
    "Octavian · Gunna · SAINt JHN"
  ],
  [
    "AWAY",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Oxlade+-+AWAY.mp3",
    "Oxlade"
  ],
  [
    "KOVERT",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Smino+-+KOVERT.mp3",
    "Smino"
  ],
  [
    "Afro Blue",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Robert+Glasper+%C2%B7+Erykah+Badu+-+Afro+Blue.mp3",
    "Robert Glasper · Erykah Badu"
  ],
  [
    "like you flip number 2",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/my+main+is+lvusm+-+like+you+flip+number+2.mp3",
    "lvusm",
    "like you flip number 2",

  ],
  [
    "Give Me Your Love",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Curtis+Mayfield+-+Give+Me+Your+Love+(Tangoterje+Edit).mp3",
    "Curtis Mayfield",
    "Give Me Your Love (Tangoterje Edit)",

  ],
  [
    "What You Saying?",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Jarreau+Vandal+x+Tom+Misch+-+What+You+Saying%3F+x+Try+Again+(Melledit).mp3",
    "Jarreau Vandal x Tom Misch",
    "What You Saying? x Try Again (Melledit)",

  ],
  [
    "luxuriate",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/lvusm+-+luxuriate+%5Bout+on+spotify%5D-1.mp3",
    "lvusm"
  ],
  [
    "why dont we",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/sans+-+why+dont+we.mp3",
    "sans"
  ],
  [
    "is it like that girl",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Meraki+Soul+-+is+it+like+that+girl.mp3",
    "Meraki Soul"
  ],
  [
    "Timbo Special Delivery",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/heine+aab%CF%86+-+lil+kim+and+timbaland+special+delivery.mp3",
    "heine aabφ",
    "lil kim and timbaland special delivery",

  ],
  [
    "worst but i made another remix",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/my+main+is+lvusm+-+worst+but+i+made+another+remix.mp3",
    "lvusm",
  ],

  [
    "what's for u",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Thrice+Groove+-+what's+for+u.mp3",
    "Thrice Groove"
  ],
  [   
    "Boyz N' Tha Hood Interlude",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/DeeDONTCARE+%7C%E3%83%88%E3%82%99%E3%82%A5%E3%82%A8%E3%82%A4%E3%83%B3+-+Boyz+N'+Tha+Hood+Interlude+%5BTrey's+Bop%5D-1.mp3",
    "DeeDONTCARE",
    "Boyz N' Tha Hood Interlude [Trey's Bop]",

  ],
  [
    "Buena Vista",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/SMOOTH+OPERATOR+3000+-+Buena+Vista.mp3",
    "SMOOTH OPERATOR 3000"
  ],
  [
    "NEEDED ME",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/pandi+-+NEEDED+ME+(FT.+J.ROBB+%26+LVUSM).mp3",
    "pandi",
    "NEEDED ME ft. j.robb & lvusm",
  ],
  [
    "La Malanga",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/SMOOTH+OPERATOR+3000+-+La+Malanga.mp3",
    "SMOOTH OPERATOR 3000"
  ],
  [
    "church logic II",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/cay+caleb.+-+church+logic+II+(for+braeden+bailey.).mp3",
    "cay caleb"
  ],
  [
    "what up, gangsta?",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/bstertheproducer+-+what+up%2C+gangsta%3F.mp3",
    "bstertheproducer"
  ],

  [
    "Shaken",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Tomi+Thomas+Music+-+Shaken(Prod.Spax).mp3",
    "Tomi Thomas Music",
    "Shaken (Prod.Spax)"
  ],
  [
    "Maliblue",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/FRVRFRIDAY+-+MALIBLUE-1.mp3",
    "frvrfriday"
  ],
  [
    "LYZEL NITES",
    "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/J.ROBB+-+LYZEL+NITES.mp3",
    "J.ROBB "
  ],
    //Abs
    [
      "before i wake",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+before+i+wake+(demo).mp3",
      "abscond",
      "before i wake (demo)",
      "5"
  
    ],
    [
      "FAUST",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+FAUST.mp3",
      "abscond"
    ],
    [
      "RUN",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/RUN+-+AMBEDO+EXCERPT+01_03.mp3",
      "abscond",
      "RUN - AMBEDO EXCERPT 01_03",
      "5"
  
    ],
    [
      "+BRIIIIIIITE",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+%2BBRIIIIIIITE.mp3",
      "abscond",
      "+BRIIIIIIITE (Unreleased)",

    ],
  
    //BabyGlobin
    [
      "48 Subs",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/48+Subs+Mix.mp3",
      "BabyGlobin",
      "48 Subs ft. Noturlover",
  
    ],
    [
      "Hurry Up",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/BabyGlobin+-+Hurry+Up.mp3",
      "BabyGlobin",
      "Hurry Up",
      "2"

    ],
    [
      "RESTART",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/BabyGlobin+-+RESTART.mp3",
      "BabyGlobin",
      "RESTART",
      "2"

    ],
  
  //Chai
  
    [
      "Tangerine",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Chai/Chai+-+Tangerine+-+good+quality.mp3",
      "Chai",
      "Tangerine",
      "1"
    ],
  
  //JnJKharia
  
    [
      "vexed.",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/JnJKhaira+-+vexed.mp3",
      "JnJKhaira",
      "vexed.",
    ],
    
    [
     "blundell.",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/blundell.wav",
      "JnJKhaira",
      "blundell. (Unreleased)",
      "0"
    ],
    [
      "earth strong.",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/earth+strong.wav",
      "JnJKhaira",
      "earth strong. (Unreleased)",
    ],
    [
      "humdila",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/humdila.wav",
      "JnJKhaira",
      "humdila (Unreleased)",
      "0"
    ],
  
  // Matt Brade
    [
      "Jerry n Georgie",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Matt+Brade/raleigh%26matt+brade+-+jerry+n+georgie.mp3",
      "raleigh & matt brade"
    ],
  
  //Noturlover
    
    [
      "Slide",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Slide+-+Noturlover+(P.+Bakedboi).mp3",
      "Noturlover (P. Bakedboi)",
      "",
      "4"
    ],
    [
      "Ayana",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Noturlover+-+Ayana+(prod+by+dax).mp3",
      "Noturlover",
      "Ayana (prod by dax)",
      "3"
  
    ],
    [
      "Mood Right",
      "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Noturlover+-+MOOD+RIGHT+(prod+by+svnred+%2B+bakedboi).mp3",
      "Noturlover",
      "Mood Right (prod by svnred + bakedboi)",
      "4"
    ],
  
    //Rod Lowkey
      [
        "97'",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+97'+feat.+Art+Of+Max+(Prod.+Juno).mp3",
        "ROD LOWKEY",
        "97' feat. Art Of Max (Prod. Juno)",
        "6"

    
      ],
      [
        "Hip Hop",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+97'+feat.+Art+Of+Max+(Prod.+Juno).mp3",
        "ROD LOWKEY",
        "Hip Hop feat. DRAZI",
        "4"
      ],
      [
        "Speak Yo",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+Speak+Yo+Shit+(Prod.+Ahwlee+%26+Dimijay).mp3",
        "ROD LOWKEY",
        "Speak Yo Shit",
        "4"

      ],
      [
        "Babies and Fools",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+Babies+and+Fools+(R.O.D+Mix).mp3",
        "ROD LOWKEY",
        "Babies and Fools (R.O.D. Mix)",
        ""

      ],
      [
        "Smooth",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/SMOOTH+SHIT+X+ROD+LOWKEY.mp3",
        "ROD LOWKEY",
        "Smooth Shit (Unreleased)",
        ""
      ],
      
  
      //Selah
      [
        "Like Me Now",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/Kid+Smoko+%26+Selah+-+Like+Me+Now-1.mp3",
        "Kid Smoko & Selah",
        "Like Me Now",
      ],
      [
        "bloom interlude",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+bloom+interlude.mp3+%5Bdemo%3F%5D.mp3",
        "Selah",
        "bloom interlude (demo)",
        "9"
      ],
      [
        "FAILED ATTEMPTS",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+FAILED+ATTEMPTS.mp3",
        "Selah",
        "FAILED ATTEMPTS",
        ""
      ],
      [
        "water",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+water.mp3",
        "Selah",
        "water",
        "8"
      ],

      //Bloodroot
      [
        "Audrey",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Bloodroot/Bloodroot+-+Audrey.mp3",
        "Bloodroot",
      ],
      [
        "Fool",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Bloodroot/Bloodroot+-+Fool.mp3",
        "Bloodroot",
      ],

      // raleighrain

      [
        "charms",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/raleighrain/raleighrain+-+charms.mp3",
        "raleighrain",
      ],
      [
        "bloo",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/raleighrain/raleighrain+-+bloo.mp3",
        "raleighrain",
      ],

      // Purple Corporation 

      [
        "Fish Out of Water",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Purple+Corporation/Purple+Corporation+-+Fish+Out+of+Water.mp3",
        "Purple Corporation",
        "",
        "7",
      ],
      [
        "Gamma Riders",
        "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Purple+Corporation/Purple+Corporation+-+Gamma+Riders.mp3",
        "Purple Corporation",
      ],
];